import { ApiService, AuthApi, UserInfoApi,PsiReportsApi, WatchListApi } from '@/api';
import {
    getJWTFromStorage,
    removeJWTFromStorage,
    saveJWTToStorage
} from '@/api/localStorage';
import {
    USER_LOGIN,
    USER_LOGOUT,
    CHECK_AUTH,
    SUCCESSFULL_REGISTRATION,
    REGISTER_USER,
    FETCH_PROFILE,
    GET_USER_INFO,
    GET_USER_CONFIG,
    FORGET_PASSWORD,
    CHECK_USER_EXISTS,
    CHECK_USER_EMAIL_EXISTS,
    RESET_PASSWORD,
    LOGIN_MARKETSMITHINDIA,
    CALLBACK_REQUEST,
    VERIFY_EMAIL,
    VALIDATE_REFERRALCODE,
    GET_USER_BROKER_TOKEN,
    GET_BROKER_ADMIN_TOKEN,
    CHECK_REGISTERED_BROKER_USER,
    CHECK_USER_CKYC,
    GET_LEGAL_AGREEMENT,
    SAVE_LEGAL_AGREEMENT
} from '@/store/actions.type';
import {
    SET_PSI_TOKEN,
    LOGOUT_USER,
    CHECK_LOCAL_STORAGE,
    SET_USER,
    SET_USER_CONFIG,
    SET_CKYC_STATUS
} from '@/store/mutations.type';

const state = {
    user: {
        bio: null,
        createdAt: '',
        email: '',
        id: null,
        image: null,
        token: '',
        updatedAt: '',
        username: '',
        isBrokerUser:false,
        isBrokerAdminUser:false
    },
    isCKYCDone:false,
    isLogin: false,
    config: {},
    loginState: false
};

const actions = {
    [GET_USER_INFO] ({ commit, dispatch }, data) {
        if (data != null) {
            return UserInfoApi.getUserInfo(data).then(data => {
                //dispatch(GET_USER_CONFIG);
                const uemail = data.data.response.user.email;
                const uid = data.data.response.user.id;
                const userType = data.data.response.user.userType;

                if (uemail && uid) {
                    saveJWTToStorage('uemail', uemail);
                    saveJWTToStorage('uid', uid);
                    saveJWTToStorage('userType', userType);
                }
                return data.data.response;
            });
        }
    },
    [GET_USER_CONFIG] ({ commit, dispatch }) {
        return UserInfoApi.getUserConfig().then(data => {
            var config = data.data.response.config;
            if (config) {
                saveJWTToStorage("access_token", config.token); // Save token
                saveJWTToStorage("token_time", new Date()); // Save token time
                saveJWTToStorage("is_super_admin", config.is_super_admin);
                saveJWTToStorage("is_admin", config.is_admin);
                saveJWTToStorage("user", config.username);
                saveJWTToStorage(
                    "portfolios",
                    JSON.stringify(config.portfolios)
                );
                saveJWTToStorage("recs", JSON.stringify(config.recs));
                saveJWTToStorage("broker_id", config.broker_id);
            }

            commit(SET_USER_CONFIG, data.data.response.config);
        });
    },
    [GET_USER_BROKER_TOKEN] ({ commit, dispatch }) {
        return PsiReportsApi.getBrokerToken().then(data => {
            var token = data.data.response.brokerToken;

            if (token) {
                saveJWTToStorage('brokerToken', token);
            }
        });
    },
    [GET_BROKER_ADMIN_TOKEN] ({ commit, dispatch },clientCode) {
        return PsiReportsApi.getBrokerAdminToken(clientCode).then(data => {
            var token = data.data.response.brokerToken;

            if (token) {
                saveJWTToStorage('brokerToken', token);
            }
        });
    },
    [CHECK_AUTH] ({ commit, dispatch }, user) {
        return new Promise((resolve, reject) => {
            var psitoken = getJWTFromStorage('psitoken');
            var obj = [];
            obj['psitoken'] = psitoken;
            var userObj = dispatch(GET_USER_INFO, psitoken);
            userObj.then(data => {
                if (data) {
                    commit(SET_USER, data);
                }
            });
            commit(CHECK_LOCAL_STORAGE, obj);

            resolve();
        });
    },
    [SUCCESSFULL_REGISTRATION] ({ commit, dispatch }, data) {
        if (!data || data.token == null) {
            return false
        } else {
            removeJWTFromStorage('psitoken');
            localStorage.removeItem('utmParams');
            var userObj = dispatch(GET_USER_INFO, data.token);
            commit(SET_PSI_TOKEN, data);
            return userObj.then(result => {
                const uemail = result.user.email;
                    const uid = result.user.id;
                if (uemail && uid) {
                    saveJWTToStorage('uemail', uemail);
                    saveJWTToStorage('uid', uid);
                }
                commit(SET_USER, result);

                return true;
            });
        }
    },
    [USER_LOGIN] ({ commit, dispatch }, user) {
        return AuthApi.login(user).then(({ data }) => {
            if (data.response.success) {
                removeJWTFromStorage('psitoken');
                var psitoken = data.response.token;
                var userObj = dispatch(GET_USER_INFO, data.response.token);
                commit(SET_PSI_TOKEN, data.response);
                return userObj.then(userData => {
                    const uemail = userData.user.email;
                    const uid = userData.user.id;

                    if (uemail && uid) {
                        saveJWTToStorage('uemail', uemail);
                        saveJWTToStorage('uid', uid);
                    }
                    commit(SET_USER, userData);

                    return data;
                });
            } else {
                return data;
            }
        });
    },
    [CHECK_USER_EXISTS] ({ commit, dispatch }, user) {
        return AuthApi.isUserExists(user).then(({ data }) => {
            if (data.response.success) {
                var psitoken = data.response.token;
                var userObj = dispatch(GET_USER_INFO, data.response.token);
                commit(SET_PSI_TOKEN, data.response);
                return userObj.then(userData => {
                    commit(SET_USER, userData);

                    return data;
                });
            } else {
                return data;
            }
        });
    },
    [CHECK_USER_EMAIL_EXISTS] ({ commit, dispatch }, email) {
        return UserInfoApi.isUserEmailExists(email).then(({ data }) => {
            return data.response;
        });
    },
    [USER_LOGOUT] ({ commit, dispatch }) {
        commit(LOGOUT_USER);
    },
    [REGISTER_USER] ({ commit }, user) {
        return AuthApi.register(user);
    },
    [RESET_PASSWORD] ({ commit }, resetPassObj) {
        return AuthApi.resetPassword(resetPassObj);
    },
    [LOGIN_MARKETSMITHINDIA] ({ }, userObj) {
        return AuthApi.loginMarketSmithIndia(userObj);
    },
    [CALLBACK_REQUEST] ({ }, callBackObj) {
        return UserInfoApi.callBackRequest(callBackObj);
    },
    [VERIFY_EMAIL] ({ }, verifyEmailObj) {
        return AuthApi.verifyEmail(verifyEmailObj);
    },
    [VALIDATE_REFERRALCODE] ({ commit, dispatch }, referralCode) {
        return UserInfoApi.validateReferralCode(referralCode);
    },

    [CHECK_REGISTERED_BROKER_USER]({ commit, dispatch },userObj) {
        return UserInfoApi.isRegisteredBrokerUser(userObj).then(data => {
            return data.data.response;

        });
    },
    [CHECK_USER_CKYC]({ commit, dispatch },userObj) {
        return UserInfoApi.getCkycStatus(userObj).then(data => {
            commit(SET_CKYC_STATUS, data.data.response.results)
            return data.data.response.results
        });
    },

    [GET_LEGAL_AGREEMENT]({ commit, dispatch },userObj) {
        return UserInfoApi.getLegalAgreement(userObj).then(data => {
            return data.data.response;

        });
    },

    async [SAVE_LEGAL_AGREEMENT] ({ commit }, params) {
        return UserInfoApi.saveLegalAgreement(params).then(({ data }) => {
            return data;
        });
    },
};
const mutations = {
    [SET_CKYC_STATUS] (state, status) {
        state.isCKYCDone = status
    },
    [CHECK_LOCAL_STORAGE] (state, token) {
        state.psitoken = token.psitoken;
        state.isLogin = true;
    },
    [SET_PSI_TOKEN] (state, data) {
        saveJWTToStorage('psitoken', data.token);
        saveJWTToStorage('brokerToken', data.brokerToken);
        state.psitoken = data.token;
        state.isLogin = true;

        if (data.config) {
            var config = data.config;
            saveJWTToStorage("access_token", config.token); // Save token
            saveJWTToStorage("token_time", new Date()); // Save token time
            saveJWTToStorage("is_super_admin", config.is_super_admin);
            saveJWTToStorage("is_admin", config.is_admin);
            saveJWTToStorage("user", config.username);
            saveJWTToStorage(
                "portfolios",
                JSON.stringify(config.portfolios)
            );
            saveJWTToStorage("recs", JSON.stringify(config.recs));
            saveJWTToStorage("broker_id", config.broker_id);
        }
    },
    [SET_USER] (state, user) {
        state.user = user.user;
        state.loginState = true;
    },
    [SET_USER_CONFIG] (state, data) {
        state.config = data;
    },
    [LOGOUT_USER] () {
        state.user = {};
        state.isLogin = false;
        state.errors = {};
        state.psitoken = {};
        removeJWTFromStorage('psitoken');
        removeJWTFromStorage("access_token");
        removeJWTFromStorage("token_time");
        removeJWTFromStorage("is_super_admin");
        removeJWTFromStorage("is_admin");
        removeJWTFromStorage("user");
        removeJWTFromStorage("portfolios");
        removeJWTFromStorage("recs");
        removeJWTFromStorage("broker_id");
        removeJWTFromStorage("brokerToken");
        removeJWTFromStorage("uid");
        removeJWTFromStorage("uemail");
        removeJWTFromStorage("arClientCode");
        removeJWTFromStorage("arClientName");
        removeJWTFromStorage("HoldingsData");
        removeJWTFromStorage("BrokerOrModelForPortfolio");
        removeJWTFromStorage("SelectedRecomm");
        removeJWTFromStorage("client");
        removeJWTFromStorage("Cash");
        removeJWTFromStorage("BrokerOrModelForRecomm");
        removeJWTFromStorage("BrokerOrModelForRecomm");


        //removeJWTFromStorage("utmParams");
    }
};

const gets = {};

export default {
    state,
    actions,
    mutations,
    gets
};



// WEBPACK FOOTER //
// ./src/store/modules/authentication.js